<template lang="pug">
	.persistent-schedule-detail(:class="{ padding: !editingCreative }")
		Loader(v-if="isLoading", :fullscreen="true")
		.flex-col.space-large(v-if="schedule")
			.flex-row.space-large.justify
				.flex-row.space-large
					.flex-col.space
						.font-small.grey.upper {{$tCaption('Run status')}}
						span {{ runStatus }}
					.flex-col.space
						.font-small.grey.upper {{$tCaption('Next execution')}}
						span {{ nextExecution && $moment(nextExecution).format('LLL') || '-' }}
				.flex-row.space-large
					template(v-if="schedule.RunStatus !== 1")
						DxButton(icon="fas fa-play", :text="$tCaption('Run once')", @click="runOnce", :disabled="!!isRunning")
						DxButton(icon="fas fa-repeat", :text="$tCaption('Run recurring')", @click="runRecurring", :disabled="!!isRunning")
					template(v-else)
						DxButton(icon="fas fa-stop", :text="$tCaption('Stop')", @click="stop", :disabled="!!isRunning")
					DxButton(icon="fas fa-trash", :text="$tCaption('Delete')", @click="remove", :disabled="!!isRunning")
			DxTabPanel.tab-panel-small(:dataSource="tabs")
				template(v-slot:title="{ data }")
					span {{data.name}}
				template(v-slot:item="{ data }")
					.tabpanel-item.padding
						template(v-if="data.id === 'config'")
							.flex-row.space-large
								.flex-col.space-medium.flex-1
									.flex-col
										.font-small.grey.upper {{$tCaption('Schedule name')}}
										DxTextBox(:value.sync="schedule.Name", stylingMode="filled")
									.flex-col
										.font-small.grey.upper {{$tCaption('Job type')}}
										DxSelectBox(:value.sync="schedule.JobType", stylingMode="filled", :dataSource="jobTypes", valueExpr="id", displayExpr="name")
									.flex-col
										.font-small.grey.upper {{$tCaption('Expires')}}
										DxDateBox(:value.sync="expire", stylingMode="filled", type="datetime", :showClearButton="true")
									.flex-col
										.font-small.grey.upper {{$tCaption('CRON expression')}}
										DxTextBox(:value.sync="schedule.CronExpression", stylingMode="filled")
								.flex-col.space-medium.flex-1
									.creative-settings.flex-col.space
										.font-big.upper.grey {{$tCaption('Creative settings')}}
										CreativeTemplatesNewCreative(v-if="creative && templateFields && schedule.JsonConfig.newsML", :templateFields="templateFields", :template="creative", :name.sync="schedule.JsonConfig.creativeName",
											:newsMLFtpMode="true", @newsML="v => $set(schedule.JsonConfig, 'newsML', v)", :newsMLData="schedule.JsonConfig.newsML")
						template(v-if="data.id === 'jobs'")
							.flex-col.space-medium.flex-1
								JobsList(:scheduleId="schedule.Oid")
</template>

<script>
	import _ from 'lodash';
	import Loader from 'app-core/Loader.vue';	
	import DxButton from 'devextreme-vue/button';
	import DxTextBox from 'devextreme-vue/text-box';
	import DxTabPanel from 'devextreme-vue/tab-panel';
	import { 
		PERSISTENT_SCHEDULE_RUN_STATUS, PERSISTENT_SCHEDULE_JOB_TYPE, PERSISTENT_SCHEDULE_POST_IMPORT_ACTION
	} from 'app-core/constants';
	import DxSelectBox from 'devextreme-vue/select-box';
	import DxDateBox from 'devextreme-vue/date-box';
	import CreativeTemplatesNewCreative from 'view/creative/CreativeTemplatesNewCreative.vue';
	import JobsList from 'view/persistentJob/List.vue';

	export default {
		translationCategory: 'persistent-schedule.Detail',
		name: 'persistent-schedule-detail',
		components: {
			Loader, DxButton, DxTextBox, DxTabPanel, DxSelectBox, DxDateBox, CreativeTemplatesNewCreative, JobsList
		},
		props: ['id', 'editingCreative', 'value'],
		data() {
			let runStatuses = PERSISTENT_SCHEDULE_RUN_STATUS.toLocale('name', this);
			let jobTypes = PERSISTENT_SCHEDULE_JOB_TYPE.toLocale('name', this);
			let postImportActions = PERSISTENT_SCHEDULE_POST_IMPORT_ACTION.toLocale('name', this);
			return {
				schedule: this.value,
				isLoading: 0,
				runStatuses,
				jobTypes,
				postImportActions,
				creative: this.editingCreative,
				isRunning: false,
				tabs: [ 
					{ id: 'config', name: this.$tCaption('Configuration') },
					{ id: 'jobs', name: this.$tCaption('Jobs') }
				],
			};
		},
		created() {
			
		},
		computed: {
			expire: {
				get: function() {
					return this.schedule?.Expire && this.schedule.Expire !== '0001-01-01T00:00:00.000Z' ? this.$moment(this.schedule.Expire) : null;
				},
				set: function(v) {
					this.schedule.Expire = !v ? '0001-01-01T00:00:00.000Z' : this.$moment(v).utc().format('YYYY-MM-DDThh:mm:ss.000[Z]');
				}
			},
			nextExecution: {
				get: function() {
					return this.schedule?.NextExecution && this.schedule.NextExecution !== '0001-01-01T00:00:00.000Z' ? this.$moment(this.schedule.NextExecution) : null;
				},
				set: function(v) {
					this.schedule.NextExecution = this.$moment(v).utc().format('YYYY-MM-DDThh:mm:ss.000[Z]');
				}
			},
			runStatus() {
				return this.runStatuses.find(f => f.id === this.schedule?.RunStatus)?.name;
			},
			templateFields() {
				return this.schedule?.JsonConfig?.templateFields;
			}
		},
		watch: {
			schedule: {
				handler() {
					if (!this.isLoading) {
						this.$set(this.schedule, '__changed', true);
					}
				},
				deep: true
			},
			value(v) {
				this.schedule = v;
			}
		},
		mounted() {
			if (__DEBUG__)
				window.persistentScheduleDetail = this;
			this.loadData();
		},		
		methods: {
			async remove() {
				this.$confirm(void 0, this.$tCaption('Are you sure you want to remove schedule?')).then(() => {
					this.isRunning++;
					this.$Data.postExternalApi('PersistentSchedule/Delete', [this.schedule.Oid]).then((r) => {
						if (r?.Success !== false) {
							if (this.editingCreative) {
								this.$emit('removed');
							}
						}
					}).finally(() => {
						if (!this.editingCreative) {
							this.$router.push({ path: '/persistent-schedule/List' });
						}
						this.isRunning--;
					});
				});
			},
			async runOnce() {
				this.isRunning++;
				try {
					await this.save();
					await this.$Data.getExternalApi('PersistentSchedule/RunOnce', `id=${this.schedule.Oid}`);
					this.$notifySuccess(this.$tCaption('Job has been run'));
				} finally {
					this.isRunning--;
				}
			},
			async runRecurring() {
				this.isRunning++;
				try {
					await this.save();
					const result = await this.$Data.getExternalApi('PersistentSchedule/RunRecurring', `id=${this.schedule.Oid}`);
					if (result?.Success) {
						this.$notifySuccess(this.$tCaption('Job has been run'));
						this.schedule.RunStatus = 1;
					}
				} finally {
					this.isRunning--;
				}
			},
			async stop() {
				this.isRunning++;
				try {
					const result = await this.$Data.getExternalApi('PersistentSchedule/Stop', `id=${this.schedule.Oid}`);
					if (result?.Success) {
						this.$notifySuccess(this.$tCaption('Job has been stopped'));
						this.schedule.RunStatus = 0;
					}
				} finally {
					this.isRunning--;
				}
			},
			async loadData() {
				this.isLoading++;
				try {
					if (!this.schedule) {
						this.schedule = (await this.$Data.getExternalApi('PersistentSchedule/Get', `id=${this.id}`));
						this.$Data.processPersistentScheduleCase(this.schedule, true);
					}

					if (!this.creative) {
						this.creative = await this.$Data.getExternalApi('Creative/GetCreative', `creativeId=${this.schedule.TargetObjectOid}`);
					}
					
					this.$set(this.schedule, 'JsonConfig', _.assign({
						templateId: this.schedule.TargetObjectOid,
						creativeName: this.$tCaption('New creative'),
						adjustLengthToTemplate: false,
						folderId: null,
						templateFields: [],
						newsML: {
							topHeadline: 3,
							topContent: 3,
							ftpImportOptions: {
								ftpUrl: '',
								ftpUser: '',
								ftpPassword: '',
								ftpDirectory: '',
								postImportAction: 0
							}
						}
					}, this.schedule.JsonConfig || {}));

					this.$set(this.schedule, '__changed', false);

					(this.creative?.JsonConfig?.templateFields || []).map(templateField => {
						if (!this.schedule.JsonConfig.templateFields.some(f => f.id === templateField.id)) {
							this.schedule.JsonConfig.templateFields.push(_.cloneDeep(templateField));
						}
					});
				} finally {
					this.$nextTick(() => this.isLoading--);
				}
			},
			async save() {
				if (this.schedule.__changed) {
					this.schedule.__changed = false;

					if (__DEBUG__)
						console.debug('Save newsML', { changed: this.schedule.__changed });

					let schedule = _.cloneDeep(this.schedule);
					this.$Data.processPersistentScheduleCase(schedule, false);

					await this.$Data.postExternalApi('PersistentSchedule/CreateUpdate', _.omit({ 
						...schedule, 
						JsonConfig: JSON.stringify(schedule.JsonConfig || {})
					}, ['LastJob', '__changed'])).finally(() => this.isLoading--);
				}
			}
		}
	};
</script>

<style lang='scss'>
	.persistent-schedule-detail {
		.creative-settings {
			padding: 20px;
			background: #fff;
		}
	}
</style>
